import { ITEM_LIST_NAME, ITEM_LIST_TYPE } from '@constants/tracking';

export const DELETE_MY_LISTS_MODAL = 'deleteMyListsModal';

export const RECENTS_ITEMS_PARAMETERS = {
    item_list_id: ITEM_LIST_NAME.recent,
    item_list_name: ITEM_LIST_NAME.recent,
    item_list_type: ITEM_LIST_TYPE.myProducts
};

export const FAVORITES_ITEMS_PARAMETERS = {
    item_list_id: ITEM_LIST_NAME.favorites,
    item_list_name: ITEM_LIST_NAME.favorites,
    item_list_type: ITEM_LIST_TYPE.myProducts
};

export const WISHLIST_ITEMS_PARAMETERS = {
    item_list_id: ITEM_LIST_NAME.wishlist,
    item_list_name: ITEM_LIST_NAME.wishlist,
    item_list_type: ITEM_LIST_TYPE.myProducts
};

export const SHARED_WISHLIST_ITEMS_PARAMETERS = {
    item_list_id: ITEM_LIST_NAME.sharedWishlist,
    item_list_name: ITEM_LIST_NAME.sharedWishlist,
    item_list_type: ITEM_LIST_TYPE.sharedWishlist
};

export const PRODUCTS_PER_PAGE = 20;
